import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseUser } from './base';

/**
 * @internal
 */
export class ApiUserAccessControl extends ApiBaseUser {
  @ApiOptions({ channel: 'accessControl.roles.delete' })
  deleteUserRole(userId: number, roleId: number, accountId: number) {
    return this.delete(`/access-control/user/${userId}/grants/${roleId}`, new DefaultParams({ account_id: accountId }));
  }

  @ApiOptions({ channel: 'accessControl.grants.put', requestType: 'raw' })
  putUserGrants(userId: number, roleId: number, accountId: number, params: ParamsAdapter) {
    return this.put(`/access-control/user/${userId}/grants/${roleId}?account_id=${accountId}`, params);
  }
}
